import { useMemo } from "react";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { filterScoresWithVariationsForSelectors } from "src/utils/actionPlanScoreFilters";
import { ScoreWithVariation } from "src/services/ScoreService";

export const useActionPlanSelectorVariations = (scoresWithVariations: ScoreWithVariation[]): ScoreWithVariation[] => {
    const { scoresForSelectors } = useActionsContext();

    return useMemo(
        () => filterScoresWithVariationsForSelectors(scoresWithVariations, scoresForSelectors),
        [scoresWithVariations, scoresForSelectors],
    );
};

export const mapVariationsToScoreCardOptions = (scoresWithVariations: ScoreWithVariation[]) =>
    scoresWithVariations.map((scoreWithVariation) => ({
        ...scoreWithVariation,
        id: scoreWithVariation.rowId,
        onClick: () => {
            scoreWithVariation.onClick();
        },
    }));
